//#region IMPORTS
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { InstoreOrder } from "../../models/instoreOrder";
//#endregion

//#region INTERFACE
interface Props {
  exportHandler: () => void;
  hide?: boolean;
  instoreOrder: InstoreOrder;
}
//#endregion

export default function InstoreOrdersTableRowActionExport({
  exportHandler,
  instoreOrder,
  hide = false,
}: Props) {
  //#region RENDER
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Export?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "export"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <DocumentArrowDownIcon
          className="h-5 w-5 text-lime-500 hover:cursor-pointer hover:text-lime-600"
          onClick={exportHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "export"} />
    </Fragment>
  ) : null;
  //#endregion
}
